










import { Vue, Component, Prop } from 'vue-property-decorator'
@Component({
  name: 'user-operation'
})
export default class extends Vue {
  @Prop({ default: false }) private cutwidth!: boolean
  @Prop({ required: false }) private styles!: object
  @Prop({ required: false }) private leftStyles!: object
}
